// in-client が backend を叩く時の base URL。
// dev: Vite proxy なし → 直接 http://localhost:8787 を叩く (apps/api の wrangler dev port)
// prod: 同一 origin か、Pages の env で上書き想定 (M11 で確定)

export const API_BASE_URL: string =
  import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8787';

// in-client が dev モードかどうかの判定。Zoom SDK が利用できない場合はモックを使う。
export const IS_DEV: boolean = import.meta.env.DEV;
